
<template>

    <mymodal ref="modal" title="Подбор объекта-аналога" ok="Применить" :reset="reset" width="1000px" without_ok without_cancel :resizable="false">

		<v-select :options="book.volumes" :clearable="false" v-model="volume" label="name" :reduce="obj => obj.name" v-on:input="set_volume" appendToBody/>

		<div v-if="selected_volume">

			<v-select class="mt-2" :options="selected_volume.sections" :clearable="false" v-model="section" label="name" :reduce="obj => obj.name" v-on:input="set_section" appendToBody/>

			<main_table v-if="section" class="mt-2" :attrs="analogues_attrs" :elements="analogues" select_mode="single" v-on:select="select">

				<template v-slot:nav_start>
						
					<span>Объекты-аналоги</span>

				</template>

				<template v-slot:table_head_params="data">
					<base-icon v-if="data.data.column == 'settings'" name="settings"/>
					<template v-else>{{ data.data.label }}</template>
				</template>

				<template v-slot:table_cell_params="data">
					<b-button v-if="data.data.field.key == 'settings'" size="sm" variant="outline-primary-dark" v-on:click="() => submit(data.data.item)">
						<base-icon name="add" />
					</b-button>
					<template v-else>{{ data.data.value }}</template>
				</template>

			</main_table>

		</div>

    </mymodal>

</template>

<script>

import api from "../../../../../../api"
import mymodal from "../../../../../widgets/modal"
import main_table from "../../../../../widgets/main_table"

export default
{
	props :
	{
		id : String,
	},

    components :
    {
        mymodal,
        main_table
    },

    data()
    {
        return {

			book : { volumes : [] },
			volume : null,
			section : null,
			selected_volume : null,
			analogue : null,

			analogues : [],
            analogues_attrs : 
            [
				{
					key : "settings",
					visible : true,
					visible_if_no_visible : true,
					params : true,
					thClass: "cell_settings_head",
					thStyle: "width: 64px;"
				},
                { key : "current_version.attrs.expensive_code", label : "Код показателя", sortable: true, thStyle: "width: 100px", },
                { key : "current_version.attrs.expensive_name", label : "Наименование показателя", sortable: true, thStyle: "width: 100px", },
                { key : "current_version.attrs.expensive_instrument", label : "Измеритель", sortable: true, thStyle: "width: 100px", },
                { key : "current_version.attrs.expensive_cost_normal", label : "Норматив цены строительства на 01.01.2023 (тыс. руб.)", sortable: true, thStyle: "width: 145px", },
                { key : "current_version.attrs.expensive_wall", label : "Стены наружные", sortable: true, thStyle: "width: 125px", },
                { key : "current_version.attrs.expensive_overlap", label : "Перекрытия", sortable: true, thStyle: "width: 125px", },
                { key : "current_version.attrs.cs", label : "КС", sortable: true, thStyle: "width: 135px", },
                // { key : "area", label : "Площадь", sortable: true, thStyle: "width: 75px", },
                // { key : "ground_floors", label : "Количество наземных этажей", },
                // { key : "roof", label : "Кровля", sortable: true, },
                // { key : "water_supply", label : "Система водоснабжения", },
            ],

        }
    },

	mounted()
	{
		api.call(this, "cadastral_expensive_books", "get_many", { limit : 1 },
			response =>
			{
				this.book = response.data[0]
			})
	},

    methods :
    {
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		check()
		{
			return this.analogue != null
		},

        execute(selected_obj)
		{
            this.selected_obj = selected_obj

            this.$refs.modal.execute()
        },

        select(items)
        {
			this.analogue = items.length ? items[0] : null
        },

        reset()
        {
			this.volume = null
			this.selected_volume = null
			this.section = null
			this.analogue = null
			this.analogues = []
		},

        submit(analogue)
        {
			
			this.$refs.modal.my_hide()
			
			if(this.selected_obj == null)
				this.$emit("set_many", analogue.id)
			else
			{
				if (this.check_roles([ 'model' ]))
				{
					const params =
					{
						id : this.id,
						obj_id : this.selected_obj.id,
						analogue_id : analogue.id,
					}
	
					api.call(this, "cadastral_cost_evaluation", "set_analogue_in_comparative_element", params, () => {
						api.show_notification(this, "Объект-аналог установлен")
						this.$emit("need_refresh")
					})
				}
			}
		},

		set_volume(volume_name)
		{
			var volume = this.book.volumes.find(volume => volume.name == volume_name)

			this.selected_volume = volume == null ? null : volume
			this.section = null
			this.analogue = null
			this.analogues = []
		},

		set_section(section_name)
		{
			if(this.selected_volume.sections.findIndex(section => section.name == section_name) >= 0)
				api.call(this, "cadastral_analogues_expensive", "get_many", { query : { "current_version.attrs.expensive_digest" : this.volume, "current_version.attrs.expensive_part" : this.section } },
					response =>
					{
						this.analogues = response.data
					})
			else
				this.analogues = []
		},
    }
}

</script>

<style scoped>
* >>> .cell_settings_head
{
	text-align: center;
	width: 4rem;
}
</style>

